import React, { useEffect, useState } from 'react';
import api, { getCsrfToken } from '../api/axios';
import { useNavigate, Link, Navigate } from 'react-router-dom';

export default function Login() {
  const [form, setForm] = useState({ login: '', password: '' });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [alreadyLoggedIn, setAlreadyLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/api/member/me')
      .then(() => setAlreadyLoggedIn(true))
      .catch(() => setAlreadyLoggedIn(false))
      .finally(() => setChecking(false));
  }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await getCsrfToken();

      const res = await api.post('/api/member/login', {
        login: form.login,
        password: form.password,
      });

      localStorage.setItem('member_user', JSON.stringify(res.data.user));
      navigate('/my-classes');
    } catch (err) {
      const message = err.response?.data?.message || 'Login gagal. Silakan coba lagi.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-warning" role="status" />
      </div>
    );
  }

  if (alreadyLoggedIn) {
    return <Navigate to="/my-classes" replace />;
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div className="card shadow">
            <div className="card-body p-4">
              <h3 className="text-center mb-4 fw-bold">
                <span style={{ color: 'black' }}>Conex</span>
                <span style={{ color: '#F68D6E' }}>see</span>
              </h3>
              <h5 className="text-center mb-4">Login Peserta</h5>

              {error && <div className="alert alert-danger">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Email / No HP / ID Peserta</label>
                  <input
                    name="login"
                    className="form-control"
                    value={form.login}
                    onChange={handleChange}
                    placeholder="Masukkan email, nomor HP, atau ID peserta"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    name="password"
                    type="password"
                    className="form-control"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Masukkan password"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-dark w-100"
                  disabled={loading}
                >
                  {loading ? 'Memproses...' : 'Login'}
                </button>
              </form>

              <div className="text-center mt-3">
                <span className="text-muted">Belum punya akun? </span>
                <Link to="/register">Daftar di sini</Link>
              </div>

              <div className="text-center mt-2">
                <small className="text-muted">
                  Sudah melakukan pembayaran? Gunakan nomor HP yang terdaftar untuk login.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
